export interface IModal {
  isOpen: boolean
  window: ModalsEnum | null
  data: TypeModalData
}

export type TypeModalData = null

export enum ModalsEnum {
  locationCreate = 'LocationCreate',
  locationDelete = 'LocationDelete',
  locationUpdate = 'LocationUpdate',
  userCreate = 'UserCreate',
  userDelete = 'UserDelete',
  userUpdate = 'UserUpdate',
}

export enum LocalesEnum {
  RUSSIAN = 'ru-RU',
  ENGLISH = 'en-US',
  JAPANESE = 'ja-JA',
  FRENCH = 'fr-FR',
  GERMAN = 'de-DE',
}
